import { DISABLE_PREV_NAV } from "../actions/types";

export default (disable = true, action) => {
  if (action.type === DISABLE_PREV_NAV) {
    return action.payload;
  }
  return disable;
};
